<!-- ================================================================
   NAVBAR — Two-row desktop + offcanvas mobile menu
   Row 1: Brand (emblem + name) + Phone/Email from API
   Row 2: Navigation + APPLY NOW (desktop only)
   Mobile: brand row + hamburger → offcanvas accordion menu
================================================================ -->

<!-- Animated gold top stripe -->
<div class="rs-header-stripe"></div>

<!-- ══════════════════════ MAIN HEADER ══════════════════════ -->
<header id="masthead" class="site-header">

  <!-- ── ROW 1: Brand identity ── -->
  <div class="rs-brand-row">
    <div class="container">
      <div class="rs-brand-row-inner">

        <!-- Logo emblem + school name from API -->
        <a class="rs-brand" routerLink="/" aria-label="Home">
          <div class="rs-brand-emblem">
            <img [src]="mainData?.LogoUrl || 'assets/img/rs-shapes/logo-white.webp'" [alt]="mainData?.Name || 'Logo'">
          </div>
          <div class="rs-brand-text" *ngIf="mainData?.Name">
            <span class="rs-brand-short">{{mainData.Name}}</span>
            <span class="rs-brand-full">{{mainData.Address}}</span>
          </div>
        </a>

        <!-- Quick contact (desktop ≥1200px only) -->
        <div class="rs-header-contact">
          <div class="rs-hc-item" *ngIf="mainData?.Phone">
            <div class="rs-hc-icon"><i class="fas fa-phone-alt"></i></div>
            <div class="rs-hc-info">
              <small>Call Us</small>
              <a [href]="'tel:' + mainData.Phone">{{mainData.Phone}}</a>
            </div>
          </div>
          <div class="rs-hc-divider"></div>
          <div class="rs-hc-item" *ngIf="mainData?.Email">
            <div class="rs-hc-icon"><i class="fas fa-envelope"></i></div>
            <div class="rs-hc-info">
              <small>Email Us</small>
              <a [href]="'mailto:' + mainData.Email">{{mainData.Email}}</a>
            </div>
          </div>
        </div>

        <!-- Mobile actions: APPLY + hamburger (visible below 1200px) -->
        <div class="rs-mobile-actions">
          <a *ngIf="onl_button" [href]="onl_button.OptionUrl" target="_blank" class="header-menu-btn">
            {{onl_button.DisplayName || 'Apply'}}
          </a>
          <a *ngIf="!onl_button" routerLink="/contact" class="header-menu-btn">Apply</a>
          <button class="header-bar-icon sidebar-toggle" aria-label="Open Menu" type="button">
            <span></span>
            <span></span>
            <span></span>
          </button>
        </div>

      </div>
    </div>
  </div>

  <!-- ── ROW 2: Navigation (desktop only) ── -->
  <div class="rs-nav-row">
    <div class="container">
      <div class="rs-nav-row-inner">

        <nav id="site-navigation" class="main-navigation">
          <ul id="menu-main-menu" class="menu">

            <!-- <li>
              <a routerLink="/" routerLinkActive="current-page-ancestor"
                 [routerLinkActiveOptions]="{exact:true}">Home</a>
            </li> -->

            <ng-container *ngFor="let item of AllmenuItems">
              <li *ngIf="item.Items.length === 0 && item.MenuCode !== 11">
                <a [routerLink]="item.MenuUrl" routerLinkActive="current-page-ancestor">{{item.DisplayName}}</a>
              </li>
              <li *ngIf="item.Items.length === 0 && item.MenuCode === 11">
                <a [href]="item.MenuUrl" target="_blank" rel="noopener">{{item.DisplayName}}</a>
              </li>
              <li *ngIf="item.Items.length > 0" class="menu-item-has-children">
                <a href="javascript:void(0)">{{item.DisplayName}}</a>
                <ul class="sub-menu">
                  <li *ngFor="let child of item.Items">
                    <a *ngIf="child.MenuCode !== 11" [routerLink]="child.MenuUrl"
                      routerLinkActive="current-page-ancestor">{{child.DisplayName}}</a>
                    <a *ngIf="child.MenuCode === 11" [href]="child.MenuUrl" target="_blank"
                      rel="noopener">{{child.DisplayName}}</a>
                  </li>
                </ul>
              </li>
            </ng-container>

          </ul>
        </nav>

        <div class="rs-nav-cta">
          <a *ngIf="onl_button" [href]="onl_button.OptionUrl" target="_blank" class="header-menu-btn">
            {{onl_button.DisplayName || 'APPLY NOW'}}
          </a>
          <a *ngIf="!onl_button" routerLink="/contact" class="header-menu-btn">APPLY NOW</a>
        </div>

      </div>
    </div>
  </div>

</header>

<!-- ══════════════════════ STICKY HEADER ══════════════════════ -->
<div id="rs-sticky-header" class="site-header rs-sticky-header">
  <div class="container">
    <div class="rs-sticky-inner">

      <a class="rs-brand rs-brand-sm" routerLink="/">
        <div class="rs-brand-emblem">
          <img [src]="mainData?.LogoUrl || 'assets/img/rs-shapes/logo-white.webp'" [alt]="mainData?.Name || 'Logo'">
        </div>
        <div class="rs-brand-text" *ngIf="mainData?.ShortName">
          <span class="rs-brand-short">{{mainData.ShortName}}</span>
        </div>
      </a>

      <nav class="sticky-nav">
        <ul class="menu">

          <ng-container *ngFor="let item of AllmenuItems">
            <li *ngIf="item.Items.length === 0 && item.MenuCode !== 11">
              <a [routerLink]="item.MenuUrl">{{item.DisplayName}}</a>
            </li>
            <li *ngIf="item.Items.length === 0 && item.MenuCode === 11">
              <a [href]="item.MenuUrl" target="_blank" rel="noopener">{{item.DisplayName}}</a>
            </li>
            <li *ngIf="item.Items.length > 0" class="menu-item-has-children">
              <a href="javascript:void(0)">{{item.DisplayName}}</a>
              <ul class="sub-menu">
                <li *ngFor="let child of item.Items">
                  <a *ngIf="child.MenuCode !== 11" [routerLink]="child.MenuUrl">{{child.DisplayName}}</a>
                  <a *ngIf="child.MenuCode === 11" [href]="child.MenuUrl" target="_blank"
                    rel="noopener">{{child.DisplayName}}</a>
                </li>
              </ul>
            </li>
          </ng-container>
        </ul>
      </nav>

      <div class="rs-sticky-right">
        <a *ngIf="onl_button" [href]="onl_button.OptionUrl" target="_blank" class="header-menu-btn">
          {{onl_button.DisplayName || 'APPLY NOW'}}
        </a>
        <a *ngIf="!onl_button" routerLink="/contact" class="header-menu-btn">APPLY NOW</a>
        <button class="header-bar-icon sidebar-toggle" aria-label="Open Menu" type="button">
          <span></span><span></span><span></span>
        </button>
      </div>

    </div>
  </div>
</div>

<!-- ══════════════════════ OFFCANVAS SIDEBAR ══════════════════════ -->
<div class="offcanvas-area">
  <div class="offcanvas-wrapper">

    <!-- Top: logo + name + close -->
    <div class="offcanvas-top">
      <div class="offcanvas-logo">
        <a routerLink="/" (click)="closeSidebar()">
          <img [src]="mainData?.LogoUrl || 'assets/img/rs-shapes/logo-white.webp'" [alt]="mainData?.Name || 'Logo'">
        </a>
        <div class="offcanvas-school-name" *ngIf="mainData?.Name">
          <strong>{{mainData.ShortName}}</strong>
          <span>{{mainData.Name}}</span>
        </div>
      </div>
      <button class="offcanvas-close-icon" type="button" aria-label="Close menu">
        <i class="fas fa-times"></i>
      </button>
    </div>

    <!-- Mobile navigation accordion -->
    <nav class="rs-mobile-nav-wrap">
      <ul class="rs-mobile-nav">

        <li class="mn-item">
          <a routerLink="/" (click)="closeSidebar()" class="mn-link">
            <i class="fas fa-home mn-icon"></i> Home
          </a>
        </li>

        <ng-container *ngFor="let item of AllmenuItems">

          <!-- Leaf — internal route -->
          <li *ngIf="item.Items.length === 0 && item.MenuCode !== 11" class="mn-item">
            <a [routerLink]="item.MenuUrl" (click)="closeSidebar()" class="mn-link">
              {{item.DisplayName}}
            </a>
          </li>

          <!-- Leaf — external URL -->
          <li *ngIf="item.Items.length === 0 && item.MenuCode === 11" class="mn-item">
            <a [href]="item.MenuUrl" target="_blank" rel="noopener" (click)="closeSidebar()" class="mn-link">
              {{item.DisplayName}}
              <i class="fas fa-external-link-alt" style="font-size:10px;opacity:.5;margin-left:4px;"></i>
            </a>
          </li>

          <!-- Parent — accordion -->
          <li *ngIf="item.Items.length > 0" class="mn-item mn-has-children" [class.mn-open]="item._mobileOpen">
            <div class="mn-parent-row">
              <span class="mn-link mn-parent-label">{{item.DisplayName}}</span>
              <button class="mn-toggle" type="button" (click)="toggleMobileMenu(item)"
                [attr.aria-expanded]="item._mobileOpen">
                <i class="fas fa-chevron-down"></i>
              </button>
            </div>
            <ul class="mn-sub" [style.maxHeight]="item._mobileOpen ? '600px' : '0'">
              <li *ngFor="let child of item.Items">
                <a *ngIf="child.MenuCode !== 11" [routerLink]="child.MenuUrl" (click)="closeSidebar()"
                  class="mn-sub-link">
                  <i class="fas fa-angle-right"></i> {{child.DisplayName}}
                </a>
                <a *ngIf="child.MenuCode === 11" [href]="child.MenuUrl" target="_blank" rel="noopener"
                  (click)="closeSidebar()" class="mn-sub-link">
                  <i class="fas fa-angle-right"></i> {{child.DisplayName}}
                </a>
              </li>
            </ul>
          </li>

        </ng-container>
      </ul>
    </nav>

    <!-- Contact info from API -->
    <div class="offcanvas-contact">
      <h4 class="offcanvas-title-meta">Contact Info</h4>
      <ul class="rs-info-list">
        <li *ngIf="mainData?.Address">
          <i class="fas fa-map-marker-alt"></i>
          <span>{{mainData.Address}}</span>
        </li>
        <li *ngIf="mainData?.Phone">
          <i class="fas fa-phone-alt"></i>
          <a [href]="'tel:' + mainData.Phone">{{mainData.Phone}}</a>
        </li>
        <li *ngIf="mainData?.Email">
          <i class="fas fa-envelope"></i>
          <a [href]="'mailto:' + mainData.Email">{{mainData.Email}}</a>
        </li>
        <li *ngIf="mainData?.WebUrl">
          <i class="fas fa-globe"></i>
          <a [href]="mainData.WebUrl" target="_blank" rel="noopener">{{mainData.WebUrl}}</a>
        </li>
      </ul>
    </div>

    <!-- Social links -->
    <div class="offcanvas-social">
      <h4 class="offcanvas-title-meta">Follow Us</h4>
      <ul>
        <li><a href="#" aria-label="Facebook"><i class="fab fa-facebook-f"></i></a></li>
        <li><a href="#" aria-label="YouTube"><i class="fab fa-youtube"></i></a></li>
        <li><a href="#" aria-label="LinkedIn"><i class="fab fa-linkedin-in"></i></a></li>
      </ul>
    </div>

  </div>
</div>

<!-- Overlay behind offcanvas -->
<div class="offcanvas-overlay body-overlay"></div>